import { Camera, Mail, MapPin, Phone } from 'lucide-react'
import { Link } from 'react-router-dom'
import { contact } from '../data/site'
import { Logo } from './Logo'

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell footer-lead reveal reveal--heading">
        <div>
          <span className="eyebrow eyebrow--light">Diamond Salon &amp; Spa</span>
          <h2>Come in. Settle down.<br />Leave feeling renewed.</h2>
        </div>
        <a className="button" href={contact.bookingUrl} target="_blank" rel="noopener noreferrer">Book an Appointment</a>
      </div>
      <div className="shell footer-main">
        <div className="footer-brand reveal">
          <Logo footer />
          <p>Personal hair and spa services in a calm, welcoming San Juan Capistrano salon.</p>
          <div className="social-links">
            <a href={contact.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Diamond Salon on Instagram"><Camera aria-hidden="true" /></a>
            <a href={contact.yelpUrl} target="_blank" rel="noopener noreferrer" aria-label="Diamond Salon on Yelp"><span aria-hidden="true">Y</span></a>
          </div>
        </div>
        <div className="footer-column reveal reveal--delay-1">
          <h3>Explore</h3>
          <Link to="/services">Services</Link>
          <Link to="/products">Products</Link>
          <Link to="/team">Our Team</Link>
          <Link to="/our-space">Our Space</Link>
          <Link to="/giving-back">Giving Back</Link>
          <Link to="/join-our-team">Join Us</Link>
        </div>
        <div className="footer-column footer-contact reveal reveal--delay-2">
          <h3>Visit &amp; Contact</h3>
          <address><a href={contact.mapsUrl} target="_blank" rel="noopener noreferrer"><MapPin aria-hidden="true" /> <span>{contact.address}</span></a></address>
          <a href={contact.phoneHref}><Phone /> <span>{contact.phoneDisplay}</span></a>
          <a href={`mailto:${contact.email}`}><Mail /> <span>{contact.email}</span></a>
          <p>Tuesday – Saturday<br />9am – 5pm</p>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="shell footer-bottom__inner reveal">
          <span>© {new Date().getFullYear()} Diamond Salon. All rights reserved.</span>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  )
}
